module.exports = __webpack_public_path__ + "static/media/milk.873f590a.svg";